/* Card share button - uses Web Share API or fallback copy */
document.addEventListener('click', function(e) {
  var btn = e.target.closest('.gkart-card-share-btn');
  if (!btn) return;
  e.preventDefault();
  e.stopPropagation();
  var url = btn.dataset.url;
  var title = btn.dataset.title;
  if (navigator.share) {
    navigator.share({ title: title, url: url }).catch(function() {});
  } else if (navigator.clipboard) {
    navigator.clipboard.writeText(url).then(function() {
      btn.style.background = 'var(--gkart-gold)';
      btn.style.color = 'var(--gkart-cream)';
      setTimeout(function() {
        btn.style.background = '';
        btn.style.color = '';
      }, 1500);
    }).catch(function() {
      window.open('mailto:?subject=' + encodeURIComponent(title) + '&body=' + encodeURIComponent(url));
    });
  } else {
    window.open('mailto:?subject=' + encodeURIComponent(title) + '&body=' + encodeURIComponent(url));
  }
});
